<template>
  <section class="custom-search">
    <div class="input-group">
      <label class="input-group-text" for="search">search by</label>
      <input type="text" id="search" class="form-control" v-model="search" />
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'search',
  computed: {
    ...mapGetters('reporting', ['analysis']),
    search: {
      get() {
        let _data = null
        if (this.analysis) {
          _data = this.analysis.search
        }
        return _data
      },
      set(value) {
        this.setAnalysisData({
          name: 'search',
          value: value,
        })
      },
    },
  },
  methods: {
    ...mapActions('reporting', ['setAnalysisData']),
  },
}
</script>
<style lang="scss" scoped>
.custom-search {
  min-width: 350px;
}
</style>
